import { Box, Flex, Tag } from "@chakra-ui/react";
import ExportMenu from "components/ExportMenu";
import {
  EmailItemResponse,
  EmailTagEnum,
  ListarFiltroEmailQuery,
} from "features/relatorios/typings";
import moment from "moment";
import { useMemo } from "react";
import { MdMailOutline, MdOutlineVisibilityOff } from "react-icons/md";
import colors from "theme/colors";

function useRelatorioEmailColumns({
  filtro,
  onExportExcel,
  onExportPdf,
}: {
  filtro: ListarFiltroEmailQuery;
  onExportPdf?: () => any;
  onExportExcel?: () => any;
}) {
  return useMemo(() => {
    return [
      {
        title: "Para",
        width: "300px",
        render: (original: EmailItemResponse) => (
          <Flex flexDir="column">
            <Box>{original.nome}</Box>
            <Flex fontSize="xs" gap="4px" alignItems="center">
              <MdMailOutline /> {original.email}
            </Flex>
          </Flex>
        ),
      },
      {
        title: "Mensagem",
        render: (original: EmailItemResponse) => (
          <Box fontWeight="400" fontSize="14px" lineHeight="14px">
            {original.assunto}
          </Box>
        ),
      },

      {
        title: (
          <ExportMenu
            onExportPdf={onExportPdf}
            onExportarXlsx={onExportExcel}
          />
        ),
        width: "230px",
        render: (original: EmailItemResponse) => {
          return (
            <Flex flexDir="column" gap="4px">
              <Box>
                <Tag
                  background="white"
                  border="1px solid"
                  borderColor={
                    original.tagType === EmailTagEnum.Success
                      ? colors.green500
                      : colors.red500
                  }
                  borderRadius={14}
                  color={
                    original.tagType === EmailTagEnum.Success
                      ? colors.green500
                      : colors.red500
                  }
                  // padding="4px 20px"
                >
                  {original.tag}
                </Tag>
              </Box>

              <Flex fontSize="xs">
                {original.tagType === EmailTagEnum.Success ? (
                  original.dataVisualizacao ? (
                    moment(original.dataVisualizacao).format(
                      "[Lido em] DD/MM/YYYY [às] HH:mm"
                    )
                  ) : (
                    <Flex gap="8px" align="center" color="#939393">
                      <MdOutlineVisibilityOff size={20} />
                      Não Lido
                    </Flex>
                  )
                ) : null}
              </Flex>
            </Flex>
          );
        },
      },
    ];
  }, [onExportExcel, onExportPdf]);
}

export default useRelatorioEmailColumns;
